import {
  AuthUserResponsePartner,
  ResponseType,
  VerifySmsInputData,
} from '../../types';
import { api } from '../api';

export const verifyPartnerSms = async (data: VerifySmsInputData) => {
  return api.post<ResponseType<AuthUserResponsePartner>>(
    '/v1/auth/verify-sms',
    data
  );
};
